import React from 'react';
import siteText from '../assets/siteText.json';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import './Reviews.css';

const defaultReviewerImageSrc = `${process.env.PUBLIC_URL}/castle-icon.png`;

function Reviews() {
  const { header, intro, reviews } = siteText.reviewsPage;

  return (
    <div className="reviews-page-container">
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mt: 4, mb: 2 }}>
        {header}
      </Typography>
      <Typography variant="subtitle1" align="center" paragraph sx={{ mb: 4 }}>
        {intro}
      </Typography>
      <Box className="reviews-list">
        {reviews.map((review, index) => {
          // Reviewer photos are served from public/images/optimized (made by scripts/optimize-images.mjs).
          // A dynamic require() here made webpack inline every image in src/assets into the bundle.
          const reviewerImageSrc = review.reviewerImage
            ? `${process.env.PUBLIC_URL}/images/optimized/${review.reviewerImage.replace(/\.[a-z]+$/i, '')}-w480.jpg`
            : defaultReviewerImageSrc;

          return (
            <Card key={index} className="review-card" sx={{ display: 'flex', mb: 3, boxShadow: 3 }}>
              <CardMedia
                component="img"
                sx={{ width: 100, height: 100, objectFit: 'cover', m: 2, borderRadius: 0, display: { xs: 'none', sm: 'none', md: 'block' } }}
                image={reviewerImageSrc}
                alt={review.reviewerName || 'Reviewer'}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                  <Typography component="div" variant="h6">
                    {review.reviewerName}
                  </Typography>
                  <Rating name={`rating-${index}`} value={review.starRating} precision={0.5} readOnly sx={{ mb: 1 }} />
                  <Typography variant="subtitle2" color="text.secondary" component="div" gutterBottom>
                    Stayed: {review.dateOfStay}
                  </Typography>
                  <Typography variant="body2" paragraph>
                    {review.reviewMessage}
                  </Typography>
                  {review.reviewLocation && (
                    <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 1, fontStyle: 'italic' }}>
                      ({review.reviewLocation})
                    </Typography>
                  )}
                </CardContent>
              </Box>
            </Card>
          );
        })}
      </Box>
    </div>
  );
}

export default Reviews;
